export function getUniqueValues<T>(
  items: T[],
  getter: (item: T) => string | null | undefined
): string[] {
  return [...new Set(items.map(getter).filter((v): v is string => !!v))].sort();
}

export function toFilterOptions(values: string[]) {
  return values.map((v) => ({ text: v, value: v }));
}
